import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root',
})
export class StudentsService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadStudentInit(cohortId: any) {
		return this.ngrxService.loadInitAPI('student', 'list', cohortId);
	}

	loadStudentApi(cohortId: number) {
		return this.getStudentList(cohortId).pipe(
			map((data: any) => {
				console.log(data);
				return this.ngrxService.loadInitData('student', 'list', cohortId, data);
			}),
		);
	}

	fetchStudentData(cohortId: any) {
		return this.ngrxService.loadData('student', 'list', cohortId);
	}

	getStudentList(cohortId: any) {
		return this.http.get(
			environment.url.cohort + `/v2/${cohortId}/students/V2`,
		);
	}

	addStudent(cohortId: any, content: any) {
		return this.http
			.post(environment.url.cohort + `/${cohortId}/student`, content, {})
			.pipe(
				tap((data: any) => {
					this.loadStudentApi(cohortId).subscribe();
				}),
			);
	}
}
